import { CARTS_RECEIVED, SET_CART } from "../types/cart";

const cartsReducer = (state, { type, payload }) => {
  switch (type) {
    case SET_CART:
      return { ...state, cart: payload };
    case CARTS_RECEIVED:
      return { ...state, cart_items: payload };
    default:
      return { ...state };
  }
};

export default cartsReducer;
